import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const StyledSvg = styled('svg')(css`
    width: 20px;
    height: 20px;
`);

// TODO: Remove this icon from app-react once it's available on component library
export const GardenSvg = () => (
    <StyledSvg
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.5 6.5C1.5 4.78897 1.95505 3.41945 2.77896 2.48435C3.59489 1.55832 4.82355 1 6.5 1C8.17645 1 9.40511 1.55832 10.221 2.48435C11.0449 3.41945 11.5 4.78897 11.5 6.5C11.5 8.21981 11.0396 10.26 10.1586 11.8544C9.37198 13.2778 8.30462 14.2612 7 14.462V9.24031L9.31235 7.39043L8.68765 6.60957L7 7.95969V6H6V7.95969L4.31235 6.60957L3.68765 7.39043L6 9.24031V14.462C4.69538 14.2612 3.62802 13.2778 2.84144 11.8544C1.96043 10.26 1.5 8.21981 1.5 6.5ZM6 15.4715C4.19716 15.2638 2.85366 13.9441 1.96618 12.338C0.994648 10.5798 0.5 8.37004 0.5 6.5C0.5 4.62118 1.00002 2.9907 2.02865 1.82326C3.06526 0.646759 4.5866 0 6.5 0C8.4134 0 9.93474 0.646759 10.9713 1.82326C12 2.9907 12.5 4.62118 12.5 6.5C12.5 8.37004 12.0054 10.5798 11.0338 12.338C10.1463 13.9441 8.80284 15.2638 7 15.4715V20H6V15.4715ZM12 16.9999L14 16.9999V15H15V16.9999H17V15H18V16.9999L20 16.9999L20 17.9999L18 17.9999V20H17V17.9999H15L15 20L14 20L14 17.9999L12 17.9999L11.9999 19.9999L10.9999 19.9999L11 17.9999H9V16.9999H11V15H12V16.9999ZM19 4.09973H17V5.09973H19V4.09973Z"
        />
    </StyledSvg>
);
